import { transitionTotalTime } from "./variables"

export const gridHeroVariants = {
    initial: {
        opacity: 0,
        transform: "translate3d(-50%, 100%, 0)"
    }, animate: {
        opacity: 1,
        transform: "translate3d(-50%, 0%, 0)",
        transition: {
            duration: 2,
            ease: [0.16, 1, 0.3, 1]
        }
    }, exit: {
        opacity: 0,
        duration: 3,
        transform: "translate3d(-50%, -100%, 0)"
    }
}

export const gridCounterScalerVariants = {
    initial: {
        transform: "scale3d(1,1,1)"
    }, animate: (i) => ({
        transform: ['scale3d(1,1,1)', 'scale3d(1,1,1)', 'scale3d(1,1,1)', `scale3d(${i[0]}, 1, 1)`],
        transition:{
            transform: {
                times: [0, 1/transitionTotalTime, i[1], 1],
                ease: [[0.87, 0, 0.13, 1], "linear", [0.16, 1, 0.3, 1]],
                duration: transitionTotalTime,
                delay: 1 //+ 0.025 * animParams[0] <= 2 ? 0 : animParams[0] <= 4 ? 1 : animParams[0] <= 7 ? 2 : animParams[0] <= 9 ? 3 : animParams <= 12 ? 4 : 5,
            }
        }
    }), exit: (i) => ({
        transform: i[5] ? `scale3d(${i[0]}, 1, 1)` : `translate3d(0, 135%, 0) scale3d(${i[0]}, 1, 1)`,
        transition: {
            duration: 0.75 + (Math.random() * 0.75),
            ease: [0.85, 0, 0.15, 1]
        }
    }),
    AExit: (i) => ({
        transform: `translate3d(0, 135%, 0) scale3d(${i[0]}, 1, 1)`,
        opacity: 0,
        transition: {
            duration: 1 + (Math.random() * 0.3),
            ease: [0.85, 0, 0.15, 1]
        }
    }),
    defaultExit: (i) => ({
        transform: i[3] && i[4] ? `translate3d(0,10%,0) scale3d(${i[0]}, 1, 1)` : `translate3d(0, 135%, 0) scale3d(${i[0]}, 1, 1)`,
        opacity: i[3] && i[4] ? 1 : 0,
        transition: {
            duration: 0.75 + (Math.random() * 0.75),
            ease: [0.85, 0, 0.15, 1]
        }
    }),
    archiveExit: (i) => ({
        transform: `translate3d(0, -135%, 0) scale3d(${i[0]}, 1, 1)`,
        opacity: 1,
        transition: {
            duration: 0.75 + (Math.random() * 0.75),
            ease: [0.85, 0, 0.15, 1]
        }
    }),
    AInViewExit: (i) => ({
        transform: `translate3d(0, 0, 0) scale3d(1, 1, 1)`,
        opacity: 0,
        transition: {
            duration: 1.2 + 0.1 * i[2],
            ease: [0.85, 0, 0.15, 1],
            opacity: {
                duration: 0.65,
                delay: 1.2 + 0.1 * i[2]
            }
        }
    })
}

export const gridAuxVariants = {
    initial: {
        opacity: 0,
        transform: "translate3d(0%, 100%, 0)"
    }, animate: (i) => ({
        opacity: 1,
        transform: "translate3d(0%, 0%, 0)",
        transition: {
            duration: 2,
            delay: i,
            ease: [0.16, 1, 0.3, 1]
        }
    }), exit: (i) => ({
        opacity: 0,
        transform: "translate3d(0%, -100%, 0)"
    })
}